import { render, staticRenderFns } from "./SoporteVideos.vue?vue&type=template&id=17a42305&scoped=true"
import script from "./SoporteVideos.vue?vue&type=script&lang=js"
export * from "./SoporteVideos.vue?vue&type=script&lang=js"
import style0 from "./SoporteVideos.vue?vue&type=style&index=0&id=17a42305&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a42305",
  null
  
)

export default component.exports